import { getAuth } from "firebase/auth";
import { app } from "../firebase";

/**
 * Axios options carrying the signed-in user's login token. The API uses it to prove that the uid the portal registers a stream
 * for really is the logged-in account. With nobody signed in it sends nothing (the API only requires it once
 * STREAM_DESIGN_REQUIRE_LOGIN is switched on).
 */
export async function loginHeader(): Promise<{ headers?: Record<string, string> }> {
  try {
    const token = await getAuth(app).currentUser?.getIdToken();
    return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
  } catch (error) {
    console.error("Could not get a login token:", error);
    return {};
  }
}
